'use client';

import ErrorBanner from '@/components/ErrorBanner';

export default function NotFound() {
  return (
    <ErrorBanner
      heading="Whoops! This page doesn't exist"
      subText="Sorry we couldn't find the page you were looking for."
    />
  );
}
